import React, { useEffect, useState } from "react";
import api from "../../api/axios";

export default function Profile() {
  const [profile, setProfile] = useState(null);
  const [loading, setLoading] = useState(true); // 👈 loading state added

  useEffect(() => {
    const loadProfile = async () => {
      try {
        const res = await api.get("/user/profile");
        setProfile(res.data);
      } catch (err) {
        console.error("Failed to load profile", err);
      } finally {
        setLoading(false); // 👈 hide loading spinner
      }
    };

    loadProfile();
  }, []);

  // ✅ Loading screen (same style as Attendance)
  if (loading) {
    return (
      <div className="d-flex flex-column justify-content-center align-items-center vh-100">
        <div
          className="spinner-border text-primary"
          role="status"
          style={{ width: "3rem", height: "3rem" }}
        >
          <span className="visually-hidden">Loading...</span>
        </div>
        <p className="mt-3 text-muted fw-semibold">Loading profile...</p>
      </div>
    );
  }

  if (!profile)
    return (
      <div className="text-center py-5 text-muted">
        Failed to load profile data.
      </div>
    );

  return (
    <div className="container py-4">
      <h2 className="fw-bold mb-4">My Profile</h2>

      <div
        className="shadow-sm p-4 rounded-4 bg-white"
        style={{ border: "1px solid #f1f1f1" }}
      >
        {/* Top Section */}
        <div className="d-flex align-items-center mb-4">
          <div
            className="rounded-circle d-flex align-items-center justify-content-center"
            style={{
              width: 80,
              height: 80,
              background: "#f7f7f7",
              border: "2px solid #eee",
            }}
          >
            <span className="fw-bold fs-3 text-secondary">
              {profile.name?.charAt(0)}
            </span>
          </div>

          <div className="ms-4">
            <h4 className="mb-1 fw-bold">{profile.name}</h4>
            <span className="text-muted">{profile.email}</span>
          </div>
        </div>

        <hr className="my-4" />

        {/* Detail Grid */}
        <div className="row g-4">
          <div className="col-md-6">
            <p className="fw-semibold text-secondary mb-1">Employee Code</p>
            <p className="fw-bold">{profile.employee_code}</p>
          </div>

          <div className="col-md-6">
            <p className="fw-semibold text-secondary mb-1">Department</p>
            <p className="fw-bold">{profile.department}</p>
          </div>

          <div className="col-md-6">
            <p className="fw-semibold text-secondary mb-1">Designation</p>
            <p className="fw-bold">{profile.designation}</p>
          </div>

          <div className="col-md-6">
            <p className="fw-semibold text-secondary mb-1">Date of Joining</p>
            <p className="fw-bold">{profile.date_of_joining}</p>
          </div>
        </div>
      </div>
    </div>
  );
}
